module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_9016.f06e8c17.png";